export const PROJECTS_ENDPOINT = '/projects';
